module.exports = __webpack_public_path__ + "img/Roane_Taylor.b423d852.png";